'use client';
import { useRef } from 'react';
/**
 * ВОЗВРАТ ФОКУСА НА КНОПКУ, ОТКРЫВШУЮ ОКНО.
 *
 * ПОЧЕМУ ЭТО НАШЕ ДЕЛО, А НЕ БИБЛИОТЕКИ. Radix возвращает фокус сам - но
 * только на свой `Dialog.Trigger`. Его закрывающий обработчик выглядит так:
 * отменить штатное восстановление фокуса и перевести его на триггер. У наших
 * окон триггера нет: они управляются состоянием и адресом (окно настроек
 * открывается по ссылке `/app/settings`, окно тарифа - из четырёх разных
 * мест). Триггера нет - фокус уходит НИКУДА, на `body`.
 *
 * Чем это плохо: человек с клавиатуры закрывает окно и оказывается в начале
 * страницы. В консоли это значит пройти Tab-ом всю верхнюю полосу и левую
 * колонку, чтобы вернуться туда, где он был. Тот же дефект чинили в
 * Фазе 3 на FlyonUI - он вернулся вместе с новой библиотекой, и ловят его
 * те же ворота (`e2e/dashboard.spec.ts`, «лист открывается повторно и
 * возвращает фокус»).
 *
 * ЧТО ЗАПОМИНАЕТСЯ. Элемент, у которого был фокус в момент ОТКРЫТИЯ.
 * Снимается он во время отрисовки, а не в эффекте: эффекты детей выполняются
 * раньше эффектов родителя, и к моменту нашего эффекта фокус уже внутри
 * окна - запоминать было бы нечего.
 */
export function useReturnFocus(open) {
    const previous = useRef(null);
    const wasOpen = useRef(false);
    if (open && !wasOpen.current && typeof document !== 'undefined') {
        previous.current = document.activeElement;
    }
    wasOpen.current = open;
    return (event) => {
        const node = previous.current;
        if (node === null || !node.isConnected)
            return;
        /* Отменяем возврат фокуса библиотеки: он уводит на несуществующий
           триггер, то есть в никуда. */
        event.preventDefault();
        node.focus();
    };
}
//# sourceMappingURL=useReturnFocus.js.map